import cn from 'classnames'
import { FileIcon, ShowreelsIcon, TimeIcon } from 'assets/icons'
import Card from 'components/Wizard/Card'
import { Content } from 'types/app'
import s from './index.module.scss'
import { CSSProperties } from 'react'
import { t } from 'helpers'

interface Props {
	content: Content
	uploaded?: Content
	onClick?: () => void
	children?: JSX.Element
	style?: CSSProperties
}

const SceneCard = ({
	content,
	uploaded,
	onClick,
	children,
	style,
}: Props): JSX.Element => {
	const sceneType =
		content &&
		Object.values(content).some((v) => {
			const value = v.toString().toLowerCase()

			return value.includes('photo') || value.includes('image')
		})
			? 'Image'
			: 'Video'

	return (
		<Card
			className={cn(s.container, 'hoverWrapperParent')}
			onClick={onClick}
			wrapperStyle={{ gap: '0px' }}
			style={{ borderRadius: '15px', ...style }}>
			<>
				{children ? (
					<div className="hoverWrapper">
						<div
							className="hoverContent hoverContentHorizontal"
							style={{ gap: '8px' }}>
							<>{children}</>
						</div>
					</div>
				) : null}

				<h4 className="textEllipsis" style={{ marginBottom: 'auto' }}>
					{content['Globalizationen-USContentTitle']}
				</h4>
				{sceneType === 'Image' ? (
					<div className={s.duration}>
						<FileIcon />
						<span className="body2-m">
							{t('APP_PHOTO_FORMATS').toLowerCase()}
						</span>
					</div>
				) : (
					<>
						{content?.Duration ? (
							<div className={s.duration}>
								<TimeIcon width="24" height="24" />
								<span className="body2-m">{`${content?.Duration} sec / ${(
									+content.Duration / 60
								).toFixed(2)} min`}</span>
							</div>
						) : null}
						{uploaded?.ContentDuration ? (
							<div className={s.duration}>
								<ShowreelsIcon />
								<span className="body2-m">{`${(
									+uploaded?.ContentDuration / 1000
								).toFixed(0)} sec / ${(
									+uploaded.ContentDuration /
									1000 /
									60
								).toFixed(2)} min`}</span>
							</div>
						) : null}
					</>
				)}
			</>
		</Card>
	)
}

export default SceneCard
